import { render } from "./Item.vue?vue&type=template&id=8068dd10"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"desktope/core/head/catalog-menu/Item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8068dd10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8068dd10', __exports__)) {
    api.reload('8068dd10', __exports__)
  }
  
  module.hot.accept("./Item.vue?vue&type=template&id=8068dd10", () => {
    api.rerender('8068dd10', render)
  })

}


export default __exports__